enum ApplicationProcessSteps {
  VerificationProcessStep = 'VerificationProcessStep',
  FailedVerificationStep = 'FailedVerificationStep',
  ApplicationDeclinedStep = 'ApplicationDeclinedStep',
  ApplicationIsNotApprovedNOAAStep = 'ApplicationIsNotApprovedNOAAStep',
  ApplicationOnlineOriginationFailedStep = 'ApplicationOnlineOriginationFailedStep',
  ApplicationIsNotApprovedStep = 'ApplicationIsNotApprovedStep',
  ApplicationPreliminaryCheckStep = 'ApplicationPreliminaryCheckStep',
  ApplicationRefiScoreStep = 'ApplicationRefiScoreStep',
  ApplicationDetailsSubmissionStep = 'ApplicationDetailsSubmissionStep',
  ApplicationRefiScoreDeclinedStep = 'ApplicationRefiScoreDeclinedStep',
  GenerateLoanOfferStep = 'GenerateLoanOfferStep',
  AdditionalDocumentsSubmissionStep = 'AdditionalDocumentsSubmissionStep',
  SignLoanAgreementStep = 'SignLoanAgreementStep',
  ContactSupportStep = 'ContactSupportStep',
  FundingFailedStep = 'FundingFailedStep',
  FundedStep = 'FundedStep',
  RefiApplicationExpiredStep = 'RefiApplicationExpiredStep',
  ApplicationNotFoundPageStep = 'ApplicationNotFoundPageStep',
  RefiApplicationInvalidStep = 'RefiApplicationInvalidStep',
  ActiveLoanOrPriorChangeOffPageStep = 'ActiveLoanOrPriorChangeOffPageStep',
  OrganicTrafficIneligibleZipCode = 'OrganicTrafficIneligibleZipCode',
  NoPreScreenedOfferFound = 'NoPreScreenedOfferFound',
}

export default ApplicationProcessSteps;
